<template lang="pug">
div
  app-divider(label="Documentos")
  .px-10
    el-table(
      :cell-style="{padding: '0', height: '5px'}"
      :data="documentos"
    )
      el-table-column.tes(label="Tipo de documento", :formatter="getTipo")
      el-table-column(label="Nome do arquivo:" :formatter="getNomeDocumento")
      el-table-column(label="Ações", prop="valor", width="60")
        template(slot-scope="scope")
          app-action-button(
              icone="download",
              text="Download",
              fontSize="18",
              @click="baixarDocumento(scope.row)"
            )
</template>
<script>
import { mapActions } from 'vuex'
import AppActionButton from '@/components/AppActionButton'
import AppDivider from '@/components/AppDivider'

export default {
  props: {
    documentos: {
      Type: Array,
      required: true
    },
    idCadastro: {
      Type: String,
      required: true
    },
    ownerDocumento: {
      Type: String,
      required: true
    },
    idMembroComunidade: {
      Type: Number,
      required: false
    },
    idBeneficiario: {
      Type: Number,
      required: false
    },
    idSocio: {
      Type: Number,
      required: false
    }
  },
  components: {
    AppActionButton,
    AppDivider
  },
  methods: {
    ...mapActions({
      downloadDocumentoCentral: 'cadastro/downloadDocumentoCentral'
    }),

    getTipo (row) {
      if (row?.tipo) {
        return row.tipo.nome
      } else if (row?.tipoDocumento) {
        return row.tipoDocumento.descricao
      } else {
        return '-'
      }
    },

    getNomeDocumento (value) {
      return value && value.caminho ? value.caminho.split('/')[5] : '-'
    },

    baixarDocumento (documentoOriginal) {
      const params = {
        documento: documentoOriginal,
        idDocumento: documentoOriginal._id || documentoOriginal.id,
        idCadastro: this.idCadastro,
        owner: this.ownerDocumento,
        idMembroComunidade: this.idMembroComunidade,
        idSocio: this.idSocio,
        idBeneficiario: this.idBeneficiario
      }
      this.downloadDocumentoCentral(params)
    }
  }
}
</script>
<style lang="scss" scoped>
.pad5 {
  padding: 10px 0;
}
.px-10 {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/common/ListagemDocumentos.vue